import { injectIntl } from "react-intl";
import React from "react";
import apiService from "src/services/api.service";

const DeletePricing = (props) => {
  const deletePricing = () => {
    apiService.deleteSmsPricing(props.pricing?._id).then(() => {
      props.close();
    });
  };

  return (
    <div className="NewStrategyModalOverlay z-[999]">
      <div className="DeleteStrategyModal">
        <div className="w-full flex justify-between">
          <div className="DeleteStrategy">
            <img
              alt="Delete"
              src="/media/icons/deleteIcon.svg"
              className="w-[18px] h-[18px]"
            />
            Delete Pricing Entry?
          </div>
          <button
            type="button"
            className="CloseIconButton"
            onClick={props.close}
          >
            <img
              alt="Close"
              src="/media/icons/closeIcon.svg"
              className="w-5 h-5"
            />
          </button>
        </div>
        <div className="flex flex-col gap-4 w-full">
          <div className="HorizontalDivider"></div>
          <div className="StrategyDeleteWarning">
            Are you sure you want to delete the SMS pricing?
            <br />
            <br />
            This action cannot be undone and may affect historical cost
            reporting.
          </div>
          <div className="HorizontalDivider"></div>
        </div>
        <div className="modal-actions">
          <button type="button" className="CloseButton" onClick={props.close}>
            Cancel
          </button>
          <button
            type="button"
            className="DeleteButton"
            onClick={deletePricing}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(DeletePricing);
